module.exports = __webpack_public_path__ + "img/zx10.6caa64ef.png";